(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-morestyle"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal() {
    var els = document.querySelectorAll('[data-hero] [data-reveal]:not(.in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { io.observe(el); });
  }
  function video() {
    var vs = document.querySelectorAll('[data-hero-video]');
    if (!vs.length) return;
    vs.forEach(function (v) {
      // Force the muted *property* (not just the attribute). iOS/Android will
      // refuse to autoplay unless muted is set on the element itself.
      v.muted = true;
      v.setAttribute('muted', '');

      var reveal = function () { v.classList.add('is-ready'); };
      var tryPlay = function () {
        var p = v.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      };

      // Reveal on the FIRST reliable signal — canplay alone is flaky on mobile
      // with preload="metadata", so we also watch loadeddata + playing.
      if (v.readyState >= 2) reveal();
      ['loadeddata', 'canplay', 'playing'].forEach(function (evt) {
        v.addEventListener(evt, reveal);
      });

      // Safety net: if events don't fire (data-saver, flaky mobile decoders),
      // reveal as soon as we have a frame or playback has actually begun.
      var tries = 0;
      var poll = setInterval(function () {
        if (v.readyState >= 2 || !v.paused) reveal();
        if (v.classList.contains('is-ready') || ++tries > 40) clearInterval(poll);
      }, 250);

      // Actively start playback — the autoplay attribute is ignored on some
      // mobile browsers until JS calls play() after muted is confirmed.
      tryPlay();

      // Pause when offscreen (battery / CPU), resume when back in view.
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { tryPlay(); }
            else { v.pause(); }
          });
        }, { threshold: 0 });
        io.observe(v);
      }
    });
  }
  function init() { reveal(); video(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal() {
    var els = document.querySelectorAll('[data-hero] [data-reveal]:not(.in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { io.observe(el); });
  }
  function video() {
    var vs = document.querySelectorAll('[data-hero-video]');
    if (!vs.length) return;
    vs.forEach(function (v) {
      // fade in once it can play
      if (v.readyState >= 3) v.classList.add('is-ready');
      else v.addEventListener('canplay', function () { v.classList.add('is-ready'); }, { once: true });
      // pause when offscreen (battery / CPU)
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { v.play().catch(function () {}); }
            else { v.pause(); }
          });
        }, { threshold: 0 });
        io.observe(v);
      }
    });
  }
  function init() { reveal(); video(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function bind() {
    document.querySelectorAll('[data-rvw-carousel]:not([data-bound])').forEach(function (root) {
      root.setAttribute('data-bound', '1');
      var track = root.querySelector('[data-rvw-track]');
      var prev = root.querySelector('[data-rvw-prev]');
      var next = root.querySelector('[data-rvw-next]');
      if (!track) return;
      function step() {
        var first = track.querySelector('.rvw-card');
        if (!first) return 320;
        return first.getBoundingClientRect().width + 18;
      }
      function update() {
        if (!prev || !next) return;
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }
  if (document.readyState !== 'loading') bind();
  else document.addEventListener('DOMContentLoaded', bind);
  document.addEventListener('shopify:section:load', bind);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vertical-feature"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var els = document.querySelectorAll('[data-vspot] [data-reveal]:not(.in)');
    if (!els.length) return;
    els.forEach(function (el) {
      var d = el.getAttribute('data-reveal-delay');
      if (d) el.style.setProperty('--reveal-delay', d + 'ms');
    });
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('in');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  // Spec sheet modal
  function bindModal() {
    var modal = document.querySelector('[data-vspot-modal]');
    if (!modal || modal.dataset.bound) return;
    modal.dataset.bound = '1';
    var titleEl = modal.querySelector('#vspot-modal-title');
    var bodyEl = modal.querySelector('[data-vspot-body]');
    var lastFocus = null;

    function open(title, content) {
      lastFocus = document.activeElement;
      titleEl.textContent = title || 'Spec sheet';
      bodyEl.innerHTML = content || '';
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var closeBtn = modal.querySelector('.vspot-modal__close');
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      bodyEl.innerHTML = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-vspot-spec]');
      if (trigger) {
        e.preventDefault();
        open(trigger.getAttribute('data-spec-title'), trigger.getAttribute('data-spec-content'));
        return;
      }
      if (e.target.closest('[data-vspot-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') close();
    });
  }
  if (document.readyState !== 'loading') bindModal();
  else document.addEventListener('DOMContentLoaded', bindModal);
  document.addEventListener('shopify:section:load', bindModal);

  // Review carousels
  function bindReviews() {
    document.querySelectorAll('[data-vspot-reviews]:not([data-bound])').forEach(function (root) {
      root.setAttribute('data-bound', '1');
      var track = root.querySelector('[data-vspot-reviews-track]');
      var prev = root.querySelector('[data-vspot-prev]');
      var next = root.querySelector('[data-vspot-next]');
      if (!track) return;
      function step() {
        var first = track.querySelector('.vspot__review');
        if (!first) return 320;
        return first.getBoundingClientRect().width + 16; // gap
      }
      function update() {
        if (!prev || !next) return;
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }
  if (document.readyState !== 'loading') bindReviews();
  else document.addEventListener('DOMContentLoaded', bindReviews);
  document.addEventListener('shopify:section:load', bindReviews);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vertical-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  function onClick(e) {
    if (e.target.closest('.vcard__cta')) return;            // let the CTA link navigate
    var card = e.target.closest('[data-vcard]');
    if (!card) return;
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) return; // desktop = hover only
    var fullLink = e.target.closest('.vcard__fulllink');
    if (fullLink) return;                                    // (hidden on touch anyway)
    e.preventDefault();
    var grid = card.closest('[data-vgrid]');
    var wasOpen = card.classList.contains('is-open');
    if (grid) {
      grid.querySelectorAll('.vcard.is-open').forEach(function (c) {
        if (c !== card) c.classList.remove('is-open');
      });
    }
    card.classList.toggle('is-open', !wasOpen);
  }
  document.addEventListener('click', onClick);
})();

  } catch(e) { console.error(e); }
})();
})();
